import {Modal} from 'bootstrap';
import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-modal-new-contact',
  templateUrl: './modal-new-contact.component.html',
  styleUrls: ['./modal-new-contact.component.css'],
  standalone: false
})
export class ModalNewContactComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;
  @Input() vm: any;
  @Output() saveNewContactEmit = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }

  saveNewContact() {
    this.saveNewContactEmit.emit();
  }
  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }
}


